import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { MessageCircle, Smartphone, CheckCircle, Star, Home, Sparkles, Footprints, ShieldCheck } from 'lucide-react';

const ShoeCareService = () => {
  return (
    <div className="bg-white font-sans text-dark overflow-hidden">
      {/* --- WHAT'S INCLUDED SECTION --- */}
        <div className="text-center mb-5">
            <h2 className="expertise-title mt-4">What's Included</h2>
            <div className="mx-auto bg-primary" style={{ width: '60px', height: '4px', borderRadius: '2px' }}></div>
          </div>
      <section className="py-5 bg-white">
        <Container>
        
          <Row className="g-3">
            {[
              "Material assessment before any product is selected",
              "Deep cleaning matched to leather, suede, nubuck, canvas, or mesh",
              "Sneaker deep clean — midsole, outsole, upper, and tongue restored to original colour",
              "Sports shoe deodourising and antibacterial insole treatment",
              "Suede nap lifting and protective spray",
              "Leather conditioning with pH-neutral, wax-free conditioner",
              "Scuff and surface scratch reduction",
              "Shade-matched polish and professional buff for leather footwear",
              "Edge and welt detailing down to the stitching line",
              "Lace cleaning or replacement on request",
              "QR-tagged, tissue-wrapped return for every pair"
            ].map((text, i) => (
              <Col md={12} lg={4} key={i}>
                <Card className="h-100 border-0 bg-light rounded-4 transition-all hover-card shadow-sm">
                  <Card.Body className="d-flex gap-3 align-items-start p-4">
                    <CheckCircle className="text-primary mt-1 flex-shrink-0" size={18} />
                    <span className="fw-medium text-secondary">{text}</span>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* --- IDEAL FOR SECTION --- */}
<section className="py-5">

  <div className="text-center mb-5">
    <h2 className="expertise-title">Ideal For</h2>
    <p className="text-info small text-uppercase fw-bold">
      Every Type of Footwear
    </p>
  </div>

  <Container>
    <Row className="justify-content-center g-4">

      {[
        { icon: <Footprints size={24}/>, name: "Sports & Sneakers" },
                { icon: <Star size={24}/>, name: "Suede & Nubuck" },
        { icon: <ShieldCheck size={24}/>, name: "Leather Shoes" },
        { icon: <Star size={24}/>, name: "Suede & Nubuck" },
        { icon: <Sparkles size={24}/>, name: "Loafers & Oxfords" },
        { icon: <CheckCircle size={24}/>, name: "Heels & Sandals" },
            { icon: <Sparkles size={24}/>, name: "Loafers & Oxfords" },
        { icon: <Home size={24}/>, name: "Canvas & Trainers" }
      ].map((item, idx) => (
        <Col xs={6} sm={4} md={3} lg={2} key={idx} className="d-flex justify-content-center">
          
          <div className="ideal-card-info text-center p-4 rounded-4 h-100">
            <div className="text-info mb-2 d-flex justify-content-center">
              {item.icon}
            </div>
            <p className="small fw-bold mb-0 text-white">
              {item.name}
            </p>
          </div>

        </Col>
      ))}

    </Row>
  </Container>

  <div className="text-center mt-5">
    <p className="fs-5 fst-italic mx-auto col-lg-8 text-muted">
      "Sports shoes and sneakers, running and gym trainers, leather and suede dress shoes, loafers, Oxfords, leather sandals, nubuck boots, canvas shoes, and dress heels."
    </p>
  </div>

</section>

      {/* --- CTA SECTION --- */}
 
    <section className="py-2 bg-light">
        <Container fluid="xl" className="my-5">
          <div className="cta-banner-dark bg-primary-dark rounded-4 p-5 text-center text-white position-relative overflow-hidden">
            <div className="position-relative z-1">
              <h2 className="display-5 fw-bold mb-4 text-center">Ready to give your shoes a new life?</h2>
              <p className="text-white-50 mb-5 fs-5">WhatsApp +971 54 571 8455 or book through the Fresh N Clean app.

.</p>
              <div className="d-flex flex-column flex-md-row justify-content-center gap-4">
                <Button variant="light" size="lg" className="px-5 py-3 fw-bold text-primary-dark d-flex align-items-center justify-content-center gap-2">
                   <span>📱</span> DOWNLOAD APP
                </Button>
                <Button 
                 onClick={() =>
    window.open(
      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
      "_blank"
    )
  } variant="success" size="lg" className="px-5 py-3 fw-bold border-0 d-flex align-items-center justify-content-center gap-2" style={{backgroundColor: '#25D366'}}>
                   <span>💬</span> WHATSAPP NOW
                </Button>
              </div>
            </div>
            <div className="blob blob-1" style={{top: '-50px', right: '-50px', background: 'rgba(255,255,255,0.05)'}}></div>
          </div>
        </Container>
      </section>
     

      {/* Custom Global CSS */}
      <style>{`
        .hover-card:hover {
          transform: translateY(-5px);
          background-color: #fff !important;
          box-shadow: 0 10px 20px rgba(0,0,0,0.08) !important;
          transition: 0.3s ease;
        }
        .hover-glow:hover {
          background-color: rgba(255,255,255,0.1) !important;
          border-color: #0dcaf0 !important;
          transition: 0.3s ease;
          cursor: default;
        }
        .hover-scale:hover {
          transform: scale(1.05);
          transition: 0.2s ease;
        }
        @media (max-width: 576px) {
          .w-sm-auto { width: auto !important; }
          .display-4 { font-size: 2.5rem; }
        }
      `}</style>

    </div>
  );
};

export default ShoeCareService;